import { POTypeEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum, IsNotEmpty } from "class-validator";




export class AssetsPoDtO {

    @ApiProperty()
    vendorId: number;

    @ApiProperty()
    saleOrderId: number;

    @ApiProperty()
    purchaseOrderDate: Date;

    @ApiProperty()
    transportation: number;

    @ApiProperty()
    expectedDeliveryDate: Date;

    @ApiProperty()
    deliveryAddress: string;

    @ApiProperty()
    billingAddress: string;

    @ApiProperty()
    paymentTerms: number;

    @ApiProperty()
    unitId?: number;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    note: string;

    @ApiProperty()
    exchangeRate: number;

    @ApiProperty()
    createdUser: string;

    @ApiProperty()
    updatedUser: string;

    @ApiProperty({ enum: Object.values(POTypeEnum) })
    @IsNotEmpty()
    @IsEnum(POTypeEnum)
    poType: POTypeEnum;

    @ApiProperty()
    purchaseOrderId?: number;
    @ApiProperty()
    poNumber?: string;

    @ApiProperty({ enum: Object.values(StatusEnum) })
    @IsNotEmpty()
    @IsEnum(StatusEnum)
    status?: StatusEnum;
}